import * as types from "../types";

const initState = {
    statusCode: ""
};

const WIPReducer = (state = initState, action) => {
    switch (action.type) {
        case types.SET_WIP_STATUS:
            return {
                ...state,
                statusCode: action.payload?.errorCode
            }
        default:
            return state;
    }
};

export default WIPReducer;
